import { render, staticRenderFns } from "./ProdMirrorSwitch.vue?vue&type=template&id=58d3466a&scoped=true&"
import script from "./ProdMirrorSwitch.vue?vue&type=script&lang=js&"
export * from "./ProdMirrorSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ProdMirrorSwitch.vue?vue&type=style&index=0&id=58d3466a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3466a",
  null
  
)

export default component.exports